import { currentLanguage } from '.'

/**
 * Locale for dates that spell out a month or weekday ("12. okt. 2026").
 *
 * Numbers and numeric dates stay nb-NO in both languages (#714), so this is
 * only for toLocaleDateString / Intl.DateTimeFormat calls with a `month:
 * 'short' | 'long'` or `weekday` option. Everything else keeps 'nb-NO'.
 */
export function dateLocale(): 'nb-NO' | 'en-GB' {
  return currentLanguage() === 'en' ? 'en-GB' : 'nb-NO'
}
